<template>
  <div class="yxtbiz-complain">
    <yxt-dialog
            :custom-class="isIe ? 'yxtbiz-complain__ie-style' : ''"
            :title="$t('pc_biz_complain_title')"
            :visible.sync="visible"
            width="640px"
            ref="drawer"
            :append-to-body="true"
            :before-close="cancel">
      <div v-show="showSuccess" class="yxtbiz-complain__success">
        <img :src="`${$staticBaseUrl}assets/d6a49468/58ae9ff1/8af4c7.png`" alt="">
        <h3>{{$t('pc_biz_complain_success')}}</h3>
      </div>
      <div class="yxtbiz-complain__content" v-show="!showSuccess">
        <yxt-form ref="complainForm" :model="form" :rules="rules" label-width="100px" is-need-require>
          <yxt-form-item :label="$t('pc_biz_complain_name')" prop="targetName">
            <div v-if="isContent"><slot name="targetName" v-if="$slots.targetName"></slot><span>{{target.targetName}}</span></div>
            <div v-else>
              <div class="notes">
                <!-- <div class="info">【{{target.targetInfo}}】</div> -->
                <div class="info">【<slot name="targetInfo" v-if="$slots.targetInfo"></slot><span v-else>{{target.targetInfo}}</span>】</div>

                <!-- 语音回答 -->

                <div v-if="target.audioUrl!==''">
                <span class="el-audio-tag hand" @click.stop="getMusic(target.audioUrl,target.targetId)">
                  <img width="20" :src="isMusicActive===target.targetId?`${$staticBaseUrl}assets/d6a49468/9caf5d97/8e82aa.gif`:`${$staticBaseUrl}assets/d6a49468/409d62ad/01cd48.png`" class="mr10 editsrc">
                  <span>{{target.audioLength}}''</span>
                </span>
                </div>
                <!-- 评论时刻笔记 -->
                <div v-else class="clamp2"><slot name="targetName" v-if="$slots.targetName"></slot><span v-else>{{ target.targetName}}</span></div>
      </div>
  </div>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_complain_category')" prop="category">
            <yxt-radio-group v-model="form.category" @change="handleChange">
              <yxt-radio v-for="catagory in categories" :key="catagory.value" :label="catagory.value">{{catagory.name}}</yxt-radio>
            </yxt-radio-group>
          </yxt-form-item>
          <yxt-form-item
                  :label="$t('pc_biz_complain_content')"
                  prop="content"
          >
            <yxt-input :placeholder="$t('pc_biz_complain_placeholder')" v-model="form.content"></yxt-input>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_complain_desp')" prop="description">
            <yxt-input type="textarea" rows="6" maxlength="200" show-word-limit v-model="form.description"></yxt-input>
          </yxt-form-item>
          <yxt-form-item prop="imgUrl" class="yxtbiz-complain__imgupload-item">
            <template slot="label">
              <div>{{$t('pc_biz_complain_ticket')}}</div>
              <div class="color-gray-7">{{form.imgUrl.length}}/5</div>
            </template>
            <upload-pic v-if="visible" :logo-url.sync="form.imgUrl"></upload-pic>
          </yxt-form-item>
        </yxt-form>
      </div>
      <span slot="footer" class="dialog-footer" v-show="!showSuccess">
        <yxt-button @click="cancel">{{$t('pc_biz_complain_cancel')}}</yxt-button>
          <yxt-button
                  type="primary"
                  @click="submit"
                  :loading="loading"
          >{{ loading ? $t('pc_biz_complain_submitting') : $t('pc_biz_complain_submit') }}</yxt-button>
      </span>
    </yxt-dialog>
  </div>
</template>

<script>
import { createComplains } from './service';
import uploadPic from './uploadPic';
import {
  Dialog,
  RadioGroup,
  Form,
  FormItem,
  Radio
} from 'yxt-pc';
const u = navigator.userAgent.toLowerCase();
const r = /opera|opr\/[\d]+/.test(u); // isOpera
const k = !r && /(msie|trident)/.test(u); // isIE
export default {
  name: 'YxtbizComplain',
  components: {
    uploadPic,
    YxtDialog: Dialog,
    YxtRadioGroup: RadioGroup,
    YxtForm: Form,
    YxtFormItem: FormItem,
    YxtRadio: Radio
  },
  props: {
    target: {
      type: Object,
      defalut: () => {
        return {
          masterId: '', // 举报对象跳转地址的id
          masterType: '', // 跳转举报内容详情的url字段
          targetId: '', // 举报对象id
          targetInfo: '', // 举报对象简单描述,xxx（被投诉人）的举报对象类型{小明的评论/xxx的语音}
          targetName: '', // 举报对象内容：知识，帖子，问题（类型123）：传标题；（类型456）：传内容；其他（类型7）：传链接;语音回答传''
          targetType: 0, // 举报对象类型(1-知识 2-帖子 3-问题 4-时刻 5-知识/帖子/时刻的评论，问题的回答 6-笔记 7-其他)
          logoUrl: '', // 知识封面or帖子/问答的第一张图片（没有图片的不传）
          audioUrl: '', // 举报语音的fileUrl
          audioLength: 0, // 举报语音的fileDuration
          configCode: '', // 后台配置CODE（sourceNo-pointNo-infoType），如：MK0001-GN0005-1
          targetCreator: '' // 举报对象的创建用户id
        };
      }
    }
  },
  data() {
    return {
      isIe: k, // 是否IE浏览器
      visible: false,
      loading: false,
      list: [],
      form: {
        category: 0,
        content: '', // 概要说明
        description: '', // 详细描述
        imgUrl: []
      },
      categories: [
        {
          value: 1,
          name: this.$t('pc_biz_complain_violent')
        },
        {
          value: 2,
          name: this.$t('pc_biz_complain_porn')
        },
        {
          value: 3,
          name: this.$t('pc_biz_complain_political')
        },
        {
          value: 4,
          name: this.$t('pc_biz_complain_vulgar')
        },
        {
          value: 5,
          name: this.$t('pc_biz_complain_other')
        }
      ],
      rules: {
        category: [
          { required: true, message: this.$t('pc_biz_complain_category_select'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('pc_biz_complain_placeholder'), trigger: 'blur' },
          { min: 2, max: 20, message: this.$t('pc_biz_complain_content_limit'), trigger: 'blur' }
        ],
        description: [
          { min: 0, max: 200, message: this.$t('pc_biz_complain_description_limit'), trigger: 'blur' }
        ]
      },
      isMusicActive: '',
      audioLengthLeft: this.target.audioLength,
      showSuccess: false
    };
  },
  computed: {
    isContent() {
      const CONTENT_TARGET_TYPES = [1, 14, 2, 3, 10, 12]; // 1:在线课堂-课程 14:知识库-知识 2:社区-帖子 3:社区-问题 10:知识讨论区-讨论 12:知识讨论区-问题
      return CONTENT_TARGET_TYPES.includes(this.target.targetType);
    }
  },
  methods: {
    handleChange() {
    },
    submit() {
      if (this.loading) {
        return;
      }
      if (this.form.category === 0) {
        this.$message.warning(this.$t('pc_biz_complain_category_select'));
        return;
      }
      if (this.form.content.length < 2 || this.form.content.length > 20) {
        this.$message.warning(this.$t('pc_biz_complain_content_limitmsg'));
        return;
      }
      let params = {
        ...this.form,
        imgUrl: this.form.imgUrl.join(';'),
        ...this.target
      };
      this.loading = true;
      createComplains(params).then(res => {
        this.loading = false;
        this.showSuccess = true;
      }).catch(() => {
        this.loading = false;
        this.$message.error(this.$t('pc_biz_complain_failed'));
      });
    },
    cancel() {
      this.$refs.complainForm.resetFields();
      this.showSuccess = false;
      this.visible = false;
    },
    getMusic(url, id) {
      try {
        let music = document.getElementById('bgMusic');
        if (id !== this.isMusicActive) {
          this.isMusicActive = id;
          music.src = url;
          music.play();
        } else {
          music.pause();
          this.isMusicActive = '';
        }
      } catch (e) {
        this.$message.warning(this.$t('pc_biz_complain_trans'), 2);
        this.isMusicActive = '';
      }
    }
  }
};
</script>
